import React, { useState } from 'react';
import ReactSelect, { components } from 'react-select';
import { connect } from 'react-redux';
import classNames from 'classnames';

import Icon, { ICON_NAMES } from 'components/Icon';
import Option from './Option';
import styles from "./style";

const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <Icon name={ICON_NAMES.arrowDropdown} />
    </components.DropdownIndicator>
  )
}

const MultiValueContainer = props => {
  return (
    <components.MultiValueContainer {...props} />
  );
};

const Select = props => {
  const handleChange = values => {
    const { field, form, isMulti } = props;
    if (!isMulti) return form.setFieldValue(field.name, values.value)
    if (values) {
      return form.setFieldValue(field.name, values.map(option => option.value));
    } else {
      return form.setFieldValue(field.name, []);
    }
  }

  const [isMenuOpen, setMenuOpen] = useState(false);

  const {
    field, form,
    options, placeholder,
    isMulti, isDisabled, isMobile, readOnly, isRequired, validationError, annotation, limitNumber, isSimple,
    labelClassName
  } = props;

  const value = isMulti
    ? options.filter(option => field.value?.includes(option.value))
    : field.value
      ? options.find(option => option.value === field.value)
      : null;
  const error = validationError || form.errors[field.name];

  const onMenuOpen = () => setMenuOpen(true);

  const onMenuClose = () => setMenuOpen(false);

  return (
    <div className={classNames(`field field-select`, {
      'field--error': (error != null) && (form.submitCount > 0 || form.touched[field.name]),
      'field--inactive': readOnly,
      'field--filled': isMenuOpen || (isMulti ? field.value && field.value.length > 0 : field.value),
    })}>
      <div className='field__data'>
        {
          <span className={`field-label field-input__label ${labelClassName}`}>
            {placeholder}
            {
              isRequired && <span className="field-label__required">*</span>
            }
          </span>
        }
        <ReactSelect
          // defaultMenuIsOpen={true}
          value={value}
          closeMenuOnSelect={!isMulti}
          options={options}
          placeholder={placeholder}
          styles={styles}
          isMulti={isMulti}
          onChange={handleChange}
          onMenuClose={onMenuClose}
          onMenuOpen={onMenuOpen}
          hideSelectedOptions={false}
          isClearable={false}
          isSearchable={!!isMulti}
          isDisabled={isDisabled || readOnly}
          isMobile={isMobile}
          hasError={(error != null) && (form.submitCount > 0 || form.touched[field.name])}
          components={{
            DropdownIndicator,
            MultiValueContainer,
            Option: (data, ...rest) => Option({ ...data, limitNumber, isSimple }, ...rest),
          }}
        />
      </div>
      {
        annotation &&
        <span className='field-annotation'>{annotation}</span>
      }
      {
        (form.submitCount > 0 || form.touched[field.name]) &&
        <span className='field-error'>{error}</span>
      }
    </div>
  );
}

export default connect(
  state => {
    return {
      isMobile: state.common.windowWidth < 992,
    }
  }
)(Select);
